import React, { useState, useEffect, useContext } from 'react'
// import { v4 as uuid } from 'uuid'
import { DraftContext } from '../components/ContextProvider'
import { EditWrapper } from '../components'
import EditorArea from '../components/EditorArea'
import { usePersonaStore } from '../store'
// import { initMultipleDataFromJson } from '../lib/utility'

function Module4() {
  const { draft, initMultipleDataFromJson } = useContext(DraftContext)
  const [module] = useState(draft.draft_id && draft ? draft : {})
  const [boardStyle, setBoardStyle] = useState('vertical')
  const boards = [
    {
      id: 1,
      title: '人物誌/編輯狀態直式',
      image: '/images/boards/module4-vertical.svg',
      key: 'vertical',
    },
    {
      id: 2,
      title: '人物誌/編輯狀態橫式',
      image: '/images/boards/module4-horizon.svg',
      key: 'horizon',
    },
  ]

  const switchBoard = (board) => {
    setBoardStyle(board)
  }

  // temp records
  const [records] = useState([])
  // const [records, setRecords] = useState([])

  // useEffect(() => {
  //   if (module.module4) {
  //     setRecords(module.module4.history && module.module4.history)
  //   }
  // }, [module])

  const { setField } = usePersonaStore((store) => ({
    user_info: store.user_info,
    quote: store.quote,
    health_advocate_profile: store.health_advocate_profile,

    setField: store.setField,
  }))

  useEffect(() => {
    const json_urls = [
      {
        url: 'data/persona/user_info.json',
        dataName: 'user_info',
      },
      {
        url: 'data/persona/quote.json',
        dataName: 'quote',
      },
      {
        url: 'data/persona/health_advocate_profile.json',
        dataName: 'health_advocate_profile',
      },
    ]

    initMultipleDataFromJson(json_urls, setField)
  }, [])

  // const [tab] = useState(0)
  const noteText =
    '生成人物誌有三個關鍵要素：<strong>「行為特徵」</strong>、<strong>「角色/職業」</strong>和<strong>「目標/任務」</strong>'

  return (
    module.module4 && (
      <EditWrapper
        setting={{
          toolbarTitle: '生成人物誌',
          toolbarTitleDesc: noteText,
          showInput: module.show_input,
          moduleTitle: module.title,
          moduleKeyword: module.module4.keyword,
          records,
          showToolbar: true,
          boards,
          boardStyle,
          switchBoard,
        }}
      >
        <div className="tab-panel">
          <EditorArea
            setting={{
              showToolbar: true,
              boardStyle,
            }}
          />
        </div>
      </EditWrapper>
    )
  )
}

export default Module4
